module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Preface#fm-1"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PREFACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Abbreviations#fm-2"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBREVIATIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#pt-1"
    }
  }, [_c('strong', [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec-1"
    }
  }, [_c('strong', [_vm._v("Name and Canonicity")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec-2"
    }
  }, [_c('strong', [_vm._v("Text and Versions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec-3"
    }
  }, [_c('strong', [_vm._v("Qumran Scrolls")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec-4"
    }
  }, [_c('strong', [_vm._v("Paragraph Divisions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec-5"
    }
  }, [_c('strong', [_vm._v("Deuteronomy Papyri")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec-6"
    }
  }, [_c('strong', [_vm._v("Date, Composition, and Authorship")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-1"
    }
  }, [_c('em', [_vm._v("The Josianic Reform")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-2"
    }
  }, [_c('em', [_vm._v("The Quest for")]), _vm._v(" Urdeuteronomium")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-3"
    }
  }, [_c('em', [_vm._v("Northern Provenance")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-4"
    }
  }, [_c('em', [_vm._v("Hezekiah’s Reform")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-5"
    }
  }, [_c('em', [_vm._v("A New Quest for")]), _vm._v(" Urdeuteronomium")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-6"
    }
  }, [_c('em', [_vm._v("The Question of Authorship")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec-7"
    }
  }, [_c('strong', [_vm._v("Ancient Near Eastern Treaties")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec-8"
    }
  }, [_c('strong', [_vm._v("Ancient Hebrew Rhetoric")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-7"
    }
  }, [_c('em', [_vm._v("Rhetorical Prose")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-8"
    }
  }, [_c('em', [_vm._v("Preached Law")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-9"
    }
  }, [_c('em', [_vm._v("Rhetoric and Composition")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec-9"
    }
  }, [_c('strong', [_vm._v("The Deuteronomic Law Code")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-10"
    }
  }, [_c('em', [_vm._v("Earlier Biblical Law")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-11"
    }
  }, [_c('em', [_vm._v("Later Biblical Law")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#sec2-12"
    }
  }, [_c('em', [_vm._v("Ancient Near Eastern Law Codes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec-10"
    }
  }, [_c('strong', [_vm._v("Deuteronomy and the Prophets")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-13"
    }
  }, [_c('em', [_vm._v("Amos")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-14"
    }
  }, [_c('em', [_vm._v("Hosea")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-15"
    }
  }, [_c('em', [_vm._v("Micah")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-16"
    }
  }, [_c('em', [_vm._v("Isaiah")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-17"
    }
  }, [_c('em', [_vm._v("Jeremiah")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec-11"
    }
  }, [_c('strong', [_vm._v("Deuteronomy and Wisdom")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-18"
    }
  }, [_c('em', [_vm._v("Humane Treatment and Benevolence to the Poor and Needy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-19"
    }
  }, [_c('em', [_vm._v("Teaching of Children")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-20"
    }
  }, [_c('em', [_vm._v("Blessing: Life, Goodness, and Longevity in the Land")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-21"
    }
  }, [_c('em', [_vm._v("Avoidance of Shame")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-22"
    }
  }, [_c('em', [_vm._v("Discerning False from True Prophets")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec-12"
    }
  }, [_c('strong', [_vm._v("Theological Ideas in Deuteronomy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-23"
    }
  }, [_c('em', [_vm._v("The Name of Yahweh")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-24"
    }
  }, [_c('em', [_vm._v("Yahweh the One and Only God")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-25"
    }
  }, [_c('em', [_vm._v("Yahweh a Holy God")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-26"
    }
  }, [_c('em', [_vm._v("Yahweh Is Heard but Not Seen")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-27"
    }
  }, [_c('em', [_vm._v("Yahweh a God of Love")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-28"
    }
  }, [_c('em', [_vm._v("Yahweh a God Faithful to His Promises")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-29"
    }
  }, [_c('em', [_vm._v("Yahweh a Righteous God")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-30"
    }
  }, [_c('em', [_vm._v("Yahweh an Impartial Judge")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-31"
    }
  }, [_c('em', [_vm._v("Israel a Holy People")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-32"
    }
  }, [_c('em', [_vm._v("The Election of Israel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-33"
    }
  }, [_c('em', [_vm._v("The Covenant at Horeb (Sinai)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-34"
    }
  }, [_c('em', [_vm._v("The Land as a Gift and Tenure in the Land")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-35"
    }
  }, [_c('em', [_vm._v("Holy War")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-36"
    }
  }, [_c('em', [_vm._v("Divine Blessing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-37"
    }
  }, [_c('em', [_vm._v("Covenant Obligations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-3"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec3-1"
    }
  }, [_vm._v("Doing the Commandments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-3"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec3-2"
    }
  }, [_vm._v("Love to Yahweh and to Others")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-3"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec3-3"
    }
  }, [_vm._v("Fear of Yahweh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-3"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec3-4"
    }
  }, [_vm._v("Walking in Yahweh’s Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-3"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec3-5"
    }
  }, [_vm._v("Serving Yahweh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-3"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec3-6"
    }
  }, [_vm._v("Gratitude to Yahweh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec-13"
    }
  }, [_c('strong', [_vm._v("The Book of Deuteronomy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-38"
    }
  }, [_c('em', [_vm._v("The First Edition (1–28)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-3"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec3-7"
    }
  }, [_vm._v("Prologue (1–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-3"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec3-8"
    }
  }, [_vm._v("The Covenant at Horeb (5–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-3"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec3-9"
    }
  }, [_vm._v("The Deuteronomic Code (12–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-3"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec3-10"
    }
  }, [_vm._v("Blessings and Curses (27–28)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-39"
    }
  }, [_c('em', [_vm._v("First Supplement (29–30)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-40"
    }
  }, [_c('em', [_vm._v("Second Supplement (31–34)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec-14"
    }
  }, [_c('strong', [_vm._v("Deuteronomy and the New Testament")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-41"
    }
  }, [_c('em', [_vm._v("The Synoptic Gospels")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-42"
    }
  }, [_c('em', [_vm._v("The Gospel of John and the Johannine Epistles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-43"
    }
  }, [_c('em', [_vm._v("Acts of the Apostles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-44"
    }
  }, [_c('em', [_vm._v("Pauline and Deutero-Pauline Letters")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-45"
    }
  }, [_c('em', [_vm._v("The Epistle of James")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-46"
    }
  }, [_c('em', [_vm._v("The Epistle to the Hebrews")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-2"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction1#sec2-47"
    }
  }, [_c('em', [_vm._v("Revelation of Saint John")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Bibliography#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("BIBLIOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Bibliography#sec-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Text and Reference Works")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Bibliography#sec-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Commentaries")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-1"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Bibliography#sec-17",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Books, Monographs, and Articles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/011_Chapter01#pt-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("TRANSLATION, NOTES, AND COMMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter01#ch-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("I."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Superscription to the Prologue and First Edition")])]), _vm._v(" ("), _c('strong', [_vm._v("1:1–5")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("II."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Prologue to the Deuteronomic Law")])]), _vm._v(" ("), _c('strong', [_vm._v("1:6–4:40")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Land Is Set Before You (1:6–46)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Pass Peaceably through Seir (2:1–8a)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Pass Peaceably by Moab (2:8b–15)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Do Not Go near Ammon (2:16–23)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("I Have Given Sihon into Your Hand (2:24–37)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("I Have Also Given Og into Your Hand (3:1–11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Apportionment of Transjordan Land (3:12–17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("H."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Focus Now Is Beyond the Jordan (3:18–22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Moses Asks to Cross the Jordan (3:23–29)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Listen to the Statutes and Ordinances and Do Them (4:1–40)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec2-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Forget Not the Horeb Revelation (4:1–24)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec2-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Will Happen If You Do Forget (4:25–40)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap3"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("III."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Refuge Cities in the Transjordan")])]), _vm._v(" ("), _c('strong', [_vm._v("4:41–43")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("IV."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Subscription to the Prologue")])]), _vm._v(" ("), _c('strong', [_vm._v("4:44–49")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("V."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Covenant at Horeb")])]), _vm._v(" ("), _c('strong', [_vm._v("5–11")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Law and Covenant (5:1–33)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec2-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("This Covenant Was with You! (5:1–5)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec2-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Ten Words (5:6–21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec2-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Moses: Mediator for Subsequent Laws (5:22–33)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Fear Yahweh and Keep the Commandment (6:1–3)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Liturgical Injunction (6:4–9)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Forget Not, Test Not (6:10–19)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec2-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Forget Not Yahweh (6:10–15)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec2-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Test Not Yahweh (6:16–19)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Mean These Commandments? (6:20–25)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("You Are a Holy People (7:1–26)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec2-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Yahweh Will Clear Away Large and Mighty Nations (7:1–6)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec2-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Yahweh Chose You Because He Loved You (7:7–11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec2-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Yahweh Will Keep Covenant and Love You (7:12–16)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec2-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Yahweh Will Defeat the Larger Nations (7:17–26)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Remember Yahweh and His Testing (8:1–20)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("H."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("You Are a Rebellious People (9:1–29)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Yahweh Will Clear Away Larger and Mightier Nations (9:1–3)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Conquest Due to Canaan’s Wickedness and Oath to the Fathers (9:4–6)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Remember Your Wilderness Rebellion (9:7–29)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec3-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Remember the Calf at Horeb and Moses’ Intercession (9:7–21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec3-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Remember Taberah, Massah, and Kibroth-hattaavah (9:22–24)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec3-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Moses’ First Intercession on the Mountain (9:25–29)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("With the Covenant Renewed the Journey Can Continue (10:1–11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Moses Makes New Tablets (10:1–5)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Journey to Moserah Where Aaron Died (10:6–7)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Levites to Carry the Ark (10:8–9)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Intercession Successful; Rise Up and Resume Your Journey (10:10–11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Fear, Walk Straight, Love, and Serve Yahweh (10:12–11:17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Circumcise Yourself to Yahweh (10:12–22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Consider Yahweh’s Discipline (11:1–9)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Promised Land Will Have Rain from Heaven (11:10–12)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("But Rain Hinges on Keeping the Commandments (11:13–17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("K."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Liturgical Injunction (11:18–21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("L."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Consequences of Obedience and Disobedience (11:22–32)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Be Very Careful with All This Commandment (11:22–25)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Blessing and the Curse (11:26–28)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Be Careful to Do the Statutes and Ordinances (11:29–32)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("VI."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Deuteronomic Code")])]), _vm._v(" ("), _c('strong', [_vm._v("12–26")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Central Sanctuary (12:1–13:1[12:32])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Destroy All Places of Their Gods (12:1–4)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("On Tithes and Offerings (12:5–14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec3-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Offerings at the Central Sanctuary (12:5–9)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec3-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Once Again: Offerings at the Central Sanctuary (12:10–14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("On the Clean and Unclean (12:15–28)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec3-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Nonsacrificial Meat in the Towns (12:15–16)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec3-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Offerings at the Central Sanctuary (12:17–19)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec3-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Nonsacrificial Meat in the Towns (12:20–25)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec3-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Holy Offerings at the Central Sanctuary (12:26–28)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Seek Not Their Gods (12:29–13:1[12:32])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XCURSUS")]), _vm._v(" 1: C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENTRALIZED")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORSHIP IN THE")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EFORMS OF")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EZEKIAH AND")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OSIAH")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Yahweh Testing for Faithfulness (13:2–19[1–18])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Beware of Prophets and Dreamers (13:2–6[1–5])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Beware of Family and Friends (13:7–12[6–11])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Beware of Worthless Men (13:13–19[12–18])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Israel a Holy People to Yahweh (14:1–21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Holiness in Lamenting (14:1–2)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Clean and Unclean Animals (14:3–8)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Clean and Unclean Waterfowl (14:9–10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Clean and Unclean Winged Creatures (14:11–20)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Holiness in Eating and Food Preparation (14:21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Tithes, Remissions, and Offerings (14:22–15:23)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Tithing Year by Year (14:22–27)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Tithing Every Three Years (14:28–29)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Remissions Every Seven Years (15:1–18)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec3-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Debt Remission (15:1–11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec3-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Remission of Hebrew Slaves (15:12–18)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06a#sec2-88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Firstborn Gifts Year by Year (15:19–23)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Keeping the Feasts (16:1–17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec2-89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Feast of Passover (16:1–8)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec2-90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Feast of Weeks (16:9–12)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec2-91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Feast of Booths (16:13–17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Office Holders in Israel (16:18–18:22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec2-92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Judge and Matters of Judgment (16:18–17:13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec3-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Appointing Judges and Officials (16:18–20)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec3-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Regarding Abominations (16:21–17:1)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec3-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Judgment for Covenant Transgressors (17:2–7)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec3-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Extraordinary Cases to the Priests and the Judge (17:8–13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec2-93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Sort of King for Israel? (17:14–20)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec2-94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Rights of the Levitical Priests (18:1–8)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec3-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Levites’ Inheritance Is Yahweh (18:1–2)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec3-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Offerings Due the Levites (18:3–5)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec3-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Altar Privileges for All Levites (18:6–8)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec2-95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("How May We Know the Word of Yahweh? (18:9–22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06b#sec3-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("No Practitioners of the Secret Arts (18:9–14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec3-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Testing for the False Yahweh Prophet (18:15–22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Judicial Procedure (19:1–21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec2-96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Cities of Refuge (19:1–13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec2-97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("No Moving of Boundary Markers (19:14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec2-98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Regarding Witnesses (19:15–21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("H."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("When You Go to War (20:1–20)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec2-99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Choosing Warriors (20:1–9)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec2-100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Conduct of Holy War (20:10–18)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec2-101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Respect Fruit Trees in a Siege! (20:19–20)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Expiation for an Unsolved Murder (21:1–9)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Marriage to a Woman War Captive (21:10–14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("K."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Rights of the Firstborn (21:15–17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("L."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Death for Rebellious Sons (21:18–21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Hanged Criminals (21:22–23)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("N."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Miscellaneous Laws (22:1–8)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec2-102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Restoring Lost Property (22:1–3)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec2-103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Lifting Up Fallen Animals (22:4)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec2-104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("No Wearing the Apparel of the Opposite Sex (22:5)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec2-105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Sparing Mother Birds (22:6–7)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06c#sec2-106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Parapets on Roofs (22:8)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("O."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("More Miscellaneous Laws (22:9–12)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("No Mixing of Seeds, Yoked Animals, and Cloths (22:9–11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Tassel Exception (22:12)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("On Chastity and Marriage (22:13–23:1[22:30])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Unchaste Brides (22:13–21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Sex with Another Married Woman (22:22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Sex with a Betrothed Girl in the City (22:23–24)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Sex with a Betrothed Girl in the Country (22:25–27)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Sex with an Unbetrothed Girl (22:28–29)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Sex with a Father’s Wife (23:1[22:30])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Q."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("On Purity and Cleanliness (23:2–19[1–18])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Purity within Yahweh’s Assembly (23:2–9[1–8])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec3-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Blemished Men Excluded (23:2–3[1–2])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec3-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Ammonites and Moabites Excluded (23:4–7[3–6])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec3-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Edomites and Egyptians Not Abominations (23:8–9[7–8])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Purity and Cleanliness in the Camp (23:10–15[9–14])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Hospitality to Runaway Slaves (23:16–17[15–16])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("No Holy Prostitutes! (23:18–19[17–18])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Laws on Loans, Vows, and Theft (23:20–26[19–25])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Loans to Brothers Interest-Free (23:20–21[19–20])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Pay Your Vows Promptly! (23:22–24[21–23])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("No Crop Stealing! (23:25–26[24–25])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Humane Laws (24:1–25:4)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Marriage, Divorce, and Remarriage (24:1–5)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec3-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Divorcee May Not Return to First Husband (24:1–4)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec3-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Newlywed War Deferment (24:5)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4a"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XCURSUS")]), _vm._v(" 2: D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IVORCE WITHIN")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UDAISM AND")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARLY")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HRISTIANITY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec2-123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Pledges and Scale Disease (24:6–13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec3-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("No Millstones as Pledges (24:6)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec3-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("No Stealing of Persons (24:7)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec3-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Warning about Scale Disease (24:8–9)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec3-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Kindness in Exacting Pledges (24:10–11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06d#sec3-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("No Sleeping in a Poor Man’s Pledge (24:12–13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec2-124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Justice and Benevolence to the Needy (24:14–22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec3-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Paying Hired Laborers (24:14–15)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec3-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Each in His Own Sin Shall Die (24:16)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec3-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("No Perversion of Judgment to the Needy (24:17–18)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec3-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Needy to Get Gleaning Rights (24:19–22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec2-125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("A Limit on Flogging (25:1–3)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec2-126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("No Muzzle on a Threshing Ox (25:4)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Miscellaneous Laws (25:5–19)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec2-127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Levirate Marriage (25:5–10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec2-128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Wives Interfering in a Fight (25:11–12)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec2-129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Just Weights and Measures (25:13–16)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec2-130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Wipe Out the Remembrance of Amalek! (25:17–19)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("U."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Rituals at the Central Sanctuary (26:1–19)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec2-131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Ritual of the Firstfruits (26:1–11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec2-132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Ritual of the Third-year Tithe (26:12–15)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06e#sec2-133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Be Careful and Do These Commands (26:16–19)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("VII."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Blessings and Curses")])]), _vm._v(" ("), _c('strong', [_vm._v("27–28")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Covenant Renewal at Shechem (27:1–26)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec2-134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Yahweh’s Law on Large Stones (27:1–8)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec2-135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Today You Have Become Yahweh’s People (27:9–10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec2-136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Let the Tribes Ascend the Mountains (27:11–13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec2-137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Let the People Say “Amen” (27:14–26)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Blessings and Curses of the Deuteronomic Covenant (28:1–68)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec2-138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("If You Obey the Covenant (28:1–14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Six Blessings (28:1–6)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Victory in Battle, Prosperity, World Respect (28:7–14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec2-139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("If You Do Not Obey the Covenant (28:15–68)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Six Curses (28:15–19)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Disease, Famine, Defeat in Battle (28:20–26)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Incurable Disease, Madness, Displacement (28:27–37)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Crop Failure, Impoverishment, Dependent Status (28:38–46)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Curses of the Siege (28:47–57)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("f)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Egypt Revisited! (28:58–68)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap4"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/018_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("VIII."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Subscription to the First Edition")])]), _vm._v(" ("), _c('strong', [_vm._v("28:69")]), _vm._v("["), _c('strong', [_vm._v("29:1")]), _vm._v("])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap3"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("IX."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("First Supplement")])]), _vm._v(" ("), _c('strong', [_vm._v("29–30")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Covenant Is Something You Do (29:1–8[2–9])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Enter into the Sworn Covenant! (29:9–28[10–29])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("When the Blessings and Curses Come upon You (30:1–10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Word Is Very Near You (30:11–14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Two Ways: Life and Death (30:15–20)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("X."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Second Supplement")])]), _vm._v(" ("), _c('strong', [_vm._v("31–34")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Moses’ Death Draws Near (31:1–32:52)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec2-140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("I Cannot Cross Over This Jordan (31:1–6)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec2-141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Joshua to Head the Army, the Law Entrusted to the Levites and Elders (31:7–13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec3-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Joshua Receives Charge from Moses (31:7–8)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec3-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("A Public Reading of the Law Every Seven Years! (31:9–13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec2-142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Yahweh Addresses Moses and Joshua (31:14–23)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec3-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Joshua to Receive His Charge (31:14–15)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec3-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Moses to Write a Song (31:16–22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec3-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c)"), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Charge to Joshua (31:23)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec2-143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Moses’ Parting Words about the Song (31:24–30)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec2-144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Song of Moses (32:1–43)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XCURSUS")]), _vm._v(" 3: H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISTORY OF")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESEARCH INTO THE")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG OF")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OSES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10a#sec2-145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Take These Words to Heart (32:44–47)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10a#sec2-146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Ascend this Mountain (32:48–52)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10a#sec-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Moses’ Departure (33:1–34:12)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10a#sec2-147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Blessing of Moses (33:1–29)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10a#sec2-148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Moses’ Death and Burial (34:1–12)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Appendix#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("APPENDIX")]), _vm._v(": Citations of Deuteronomy in the New Testament")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4290e24c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0